<template>
    <div>
        <div v-if="windowWidth > 1279" class="s_1280">
            <!-- top panel -->
            <nav class="navbar wrapper navbar-expand-md fixed-top">
                <div class="col-5 menu-right">
                    <router-link to="/home">
                        <img class="logo-img" id="logo-btn" src="images/logo.png" />
                    </router-link>
                </div>
                <div class="col-7">
                    <div class="navigation">
                        <TopMenu></TopMenu>
                    </div>
                </div>
            </nav>

            <div class="main registration reg">
                <div class="container-fluid wrapper">

                    <div class="row auth-box reg-box">

                        <div class="col-5">
                            <h1>Authorise</h1>
                            <p>Please fill-in your email address, evisa application number, and your passport number to log into the evisa system</p>
                        </div>

                        <div class="col-7">
                            <div class="reg-form auth top98">
                                <form class="k-form" @submit="handleSubmit" novalidate="true">
                                    <div class="form-group row">
                                        <input type="email" v-model="model.email"
                                               autocomplete="off"
                                               onfocus="this.placeholder = ''"
                                               onblur="this.placeholder = 'email'"
                                               name="email"
                                               placeholder="email" />
                                    </div>
                                    <div class="form-group row">
                                        <input type="text" v-model="model.appNum"
                                               autocomplete="off"
                                               onfocus="this.placeholder = ''"
                                               onblur="this.placeholder = 'Application number'"
                                               name="appNum"
                                               placeholder="Application number" />

                                    </div>
                                    <div class="form-group row">
                                        <input type="text" v-model="model.passNum"
                                               autocomplete="off"
                                               onfocus="this.placeholder = ''"
                                               onblur="this.placeholder = 'Passport number'"
                                               name="passNum"
                                               placeholder="Passport number" />
                                    </div>
                                    <div class="form-group row">
                                        <div class="col-sm-12 submit-row">
                                            <button type="submit" class="btn btn-primary">Authorise</button>
                                        </div>
                                    </div>
                                    <div class="form-group row remark" v-if="errors.length">
                                        <div class="col-sm-5">
                                            <div class="red-astr"></div>
                                            <div class="error">Error</div>
                                        </div>
                                        <div class="col-sm-7">
                                            <div class="err-desc" v-for="error in errors">
                                                <span>{{ error }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>  <!-- reg-form top98 -->
                        </div>   <!-- col-7-->

                    </div> <!-- row reg-box -->

                </div> <!-- container-fluid wrapper -->
            </div> <!-- main registration reg -->

        </div>
        <div v-else class="bg white s_768">
            <div class="d-flex flex-column flex-md-row align-items-center mb-3 bg-white">
                <div class="container-fluid wrapper index">
                    <div class="nav-top row">
                        <div class="col-4">
                            <router-link to="/home">
                                <img class="logo-img" id="logo-btn" src="images/logo.png" />
                            </router-link>
                        </div>
                        <div class="col-8">
                            <div class="navigation">
                                <TopMenu :ShowContinueSubmission=true></TopMenu>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 top64 bt48">
                    <h2 class="bt-24">Authorise</h2>
                    <p>Please fill-in your email address, evisa application number, and your passport number to log into the evisa system</p>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="reg-form auth">
                        <form class="k-form" @submit="handleSubmit" novalidate="true">
                            <div class="form-group row">
                                <input type="email" v-model="model.email"
                                       autocomplete="off"
                                       onfocus="this.placeholder = ''"
                                       onblur="this.placeholder = 'email'"
                                       name="email"
                                       placeholder="email" />
                            </div>
                            <div class="form-group row">
                                <input type="text" v-model="model.appNum"
                                       autocomplete="off"
                                       onfocus="this.placeholder = ''"
                                       onblur="this.placeholder = 'Application number'"
                                       name="appNum"
                                       placeholder="Application number" />

                            </div>
                            <div class="form-group row">
                                <input type="text" v-model="model.passNum"
                                       autocomplete="off"
                                       onfocus="this.placeholder = ''"
                                       onblur="this.placeholder = 'Passport number'"
                                       name="passNum"
                                       placeholder="Passport number" />
                            </div>
                            <div class="form-group row">
                                <div class="col-sm-12 submit-row">
                                    <button type="submit" class="btn btn-primary">Authorise</button>
                                </div>
                            </div>
                            <div class="form-group row remark" v-if="errors.length">
                                <div class="col-sm-5">
                                    <div class="red-astr"></div>
                                    <div class="error">Error</div>
                                </div>
                                <div class="col-sm-7">
                                    <div class="err-desc" v-for="error in errors">
                                        <span>{{ error }}</span>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="placeholder top16">
                        <img src="/images/bird-app-768.jpg" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import TopMenu from "./Menu";
    export default {
        components: {
            TopMenu
        },
        name: 'Authorise',

        data: () => ({
            errors: [],
            model: {},
            windowWidth: window.innerWindow
        }),
        watch: {
            windowWidth(newWidth, oldWidth) {
                //console.log ("it changed to "+newWidth+" from " +oldWidth);
            }
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.onResize);
        },
        mounted() {
            this.windowWidth = window.innerWidth;
            this.$nextTick(() => {
                window.addEventListener('resize', this.onResize);
            })
        },
        computed: {
        },
        methods: {
            onResize() {
                this.windowWidth = window.innerWidth
            },
            async login() {
                try {
                    const response = await fetch(this.$apiip + '/api/v1/application/login', {
                        method: 'POST',
                        body: JSON.stringify(this.model),
                        headers: { 'Content-type': 'application/json; charset=UTF-8' },
                    })
                    const data = await response.json()
                    if (data != null) {
                        if (data.Status == 0) {
                            this.errors.push("Data you provided is incorrect");
                        }
                        if (data.Status == 1) {
                            this.$cookie.set('eVisaAppID', this.model.appNum, 7);
                            this.$router.push('prepayment');
                        }
                        if (data.Status == 2) {
                            this.$cookie.set('eVisaAppID', this.model.appNum, 7);
                            this.$router.push('appdetails');
                        }
                        if (data.Status == 3) {
                            this.$cookie.set('eVisaAppID', this.model.appNum, 7);
                            this.$router.push('status');
                        }
                    }
                } catch (error) {
                    console.error(error)
                }
            },
            handleSubmit(event) {
                //console.log('handle submit');
                event.preventDefault();
                this.errors = [];

                if (!this.model.email) {
                    this.errors.push("Email is required.");
                } else {
                    if (!this.validEmail(this.model.email)) {
                        this.errors.push("Valid email required.");
                    }
                }

                if (!this.model.appNum) {
                    this.errors.push("Application No is required.");
                } else {
                    if (this.model.appNum.length != 13) {
                        this.errors.push("Application No length must be 13.");
                    }
                }

                if (!this.model.passNum) {
                    this.errors.push("Passport No is required.");
                } else {
                    if (this.model.passNum.length < 6) {
                        this.errors.push("Passport length must be 6-9 characters.");
                    }
                }

                if (this.errors.length == 0)
                    this.login();
            },
            validEmail: function (email) {
                var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            }
        }
    }
</script>

<style scoped>
</style>